export default __webpack_public_path__ + "resources/icons/n132-2472.png";